/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetExportRequestsQueryResponse,
  GetExportRequestsQueryParams,
} from "../types/GetExportRequests.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getExportRequestsQueryKey = (
  params: GetExportRequestsQueryParams
) =>
  [{ url: "/v1/export/export-requests" }, ...(params ? [params] : [])] as const

export type GetExportRequestsQueryKey = ReturnType<
  typeof getExportRequestsQueryKey
>

/**
 * @summary Get export requests list
 * {@link /v1/export/export-requests}
 */
export async function getExportRequests(
  params: GetExportRequestsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetExportRequestsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/export/export-requests`,
    params,
    ...requestConfig,
  })
  return res
}

export function getExportRequestsQueryOptions(
  params: GetExportRequestsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getExportRequestsQueryKey(params)
  return queryOptions<
    ResponseConfig<GetExportRequestsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetExportRequestsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getExportRequests(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get export requests list
 * {@link /v1/export/export-requests}
 */
export function useGetExportRequests<
  TData = ResponseConfig<GetExportRequestsQueryResponse>,
  TQueryData = ResponseConfig<GetExportRequestsQueryResponse>,
  TQueryKey extends QueryKey = GetExportRequestsQueryKey,
>(
  params: GetExportRequestsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetExportRequestsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getExportRequestsQueryKey(params)

  const query = useQuery(
    {
      ...getExportRequestsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
